const getUrlParameter = (name: string): string => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const REGEX = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const RESULTS = REGEX.exec(location.search);
  return RESULTS === null
    ? ''
    : decodeURIComponent(RESULTS[1].replace(/\+/g, ' '));
};

const noURLParams = (): boolean => {
  const URL: string = window.location.href;
  return (
    URL.indexOf('?') !== -1 &&
    URL.indexOf('&') !== -1 &&
    URL.indexOf('=') !== -1
  );
};

export default {
  getUrlParameter,
  noURLParams,
};
